// @ts-nocheck
import { useSearchParams } from '@modern-js/runtime/router';
import { Flex, Select, Input, Button, Tooltip, Table } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React, { FC, useEffect, useState, useRef } from 'react'
import { CombinedAttachmentUpload } from '../upload';
import ExclamationCircle from './../../../../../public/drawer/ExclamationCircle.svg'
import { TransactionsService } from '@/services/transactions';
import { removeEmpty } from '@/util/params';
import dayjs from 'dayjs';
import { SearchOutlined } from '@ant-design/icons';
import { GlobalStore } from '@/stores/global';

type Props = {
    fetchComplaintReasons: () => void;
    complaintReasonCodeLists: any;
    handleChange: (key: string, val: string) => void;
    selected: any
    form: any
    disable?: boolean
    reasonCode: number
    id: number
    setSelectedRow: any
    pendCheck: boolean
}

export const ComplaintDetailEdit: FC<Props> = (_props) => {
    const globalStore = GlobalStore.useContainer();
    const [loading, setLoading] = useState(false);
    const [isEmpty, setIsEmpty] = useState(false);
    const [searchParams] = useSearchParams();
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
    const [referenceList, setReferenceList] = useState<any>([]);

    // Search state for searchable columns
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys: string[], confirm: () => void, dataIndex: string) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void, confirm: () => void) => {
        clearFilters();
        setSearchText('');
        confirm();
    };
    const getColumnSearchProps = (dataIndex: string, placeholder: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${placeholder}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Flex gap={8}>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ flex: 1 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, confirm)}
                        size="small"
                        style={{ flex: 1 }}
                    >
                        Reset
                    </Button>
                </Flex>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value: string, record: any) =>
            record[dataIndex]
                ?.toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible: boolean) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
    });

    const column = [
        {
            title: 'Toll Plaza',
            dataIndex: 'toll_plaza',
            // Search on first column
            ...getColumnSearchProps('toll_plaza', 'Toll Plaza'),
            render: (value: any, record: any) => (
                <span style={{ fontSize: '12px', textTransform: 'capitalize' }}>
                   {record.toll_plaza ==="Unknown" ? "New Plaza" :record.toll_plaza}
                </span>
            ),
        },
        {
            title: 'Transaction ID',
            dataIndex: 'transaction_id',
            // Search on second column
            ...getColumnSearchProps('transaction_id', 'Transaction ID'),
            ellipsis: true,
            render: (value: any, record: any) => {
                return (
                    <span style={{ fontSize: '12px' }}>{record.transaction_id}</span>
                )
            }
        },
        {
            title: 'Transaction Date',
            dataIndex: 'transaction_date_time',
            // Sort on third column
            sorter: (a: any, b: any) =>
                dayjs(a.transaction_date_time).unix() - dayjs(b.transaction_date_time).unix(),
            sortDirections: ['ascend', 'descend'],
            render: (value: any) => (
                <span style={{ fontSize: '12px' }}>
                    {dayjs(value).format('DD/MM/YYYY HH:mm:ss')}
                </span>
            ),
        },
        {
            title: 'Transaction Amount',
            dataIndex: 'transaction_amount',
            // Sort on fourth column
            sorter: (a: any, b: any) =>
                a.transaction_amount?.amount - b.transaction_amount?.amount,
            sortDirections: ['ascend', 'descend'],
            render: (value: any) => (
                <span style={{ fontSize: '12px' }}>
                    {value?.amount} {value?.currency_symbol}
                </span>
            ),
        },
    ];
    const [selectedRowKey, setSelectedRowKey] = useState<any>(null);

    const rowSelection = {
        type: 'checkbox' as const,
        selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
        getCheckboxProps: (record: any) => ({
            disabled: record.transaction_id === _props.id,
        }),
        hideSelectAll: true,
        onSelect: (record: any) => {
            if (selectedRowKey === record.key) {
                setSelectedRowKey(null);
                _props.setSelectedRow(null);
            } else {
                setSelectedRowKey(record.key);
                _props.setSelectedRow(record);
            }
        },
    };
    const init = async () => {
        try {
            setLoading(true);
            setIsEmpty(false);
            const transactionId = searchParams.get('bst_transaction_id');
            const payload = removeEmpty({
                page: 1,
                size: 100,
                transaction_id: transactionId,
                reason_code: _props.reasonCode,
            });
            const res = await TransactionsService.getReferenceTransactionData(payload);
            const d = res?.data?.data || [];
            if (d.length === 0) {
                setIsEmpty(true);
                setReferenceList([]);
                return;
            }
            setReferenceList(d);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (_props.reasonCode) {
            init();
        }
    }, [_props.reasonCode]);
    const eligibleAm = _props.selected?.eligible_amount?.amount;
    const transactionAmo = _props.selected?.transaction_amount?.amount
    const maxAmount = eligibleAm !== 0 ? eligibleAm : transactionAmo
    return (
        <div>
            <form onSubmit={(e) => e.preventDefault()}>
                <Flex gap="middle" vertical>

                    <div onClick={_props.fetchComplaintReasons}>
                        <p>Chargeback Reason</p>
                        <Select
                            size="large"
                            placeholder="Chargeback Reason"
                            value={_props.form.complaint_reason || undefined}
                            onChange={(val) => _props.handleChange('complaint_reason', val)}
                            style={{ width: '100%' }}
                            options={_props.complaintReasonCodeLists}
                        />
                    </div>
                    <div className="">
                        {
                            !_props.pendCheck ? <div>
                                {referenceList?.length > 0 && (
                                    <div>
                                        <span style={{ fontWeight: "500", fontSize: "15px", }}>Select Corresponding Transaction</span>
                                        <div
                                            style={{
                                                height: '300px',
                                                maxHeight: '300px',
                                                overflow: 'scroll',
                                                paddingTop: '10px',
                                            }}
                                        >
                                            <Table<any>
                                                loading={loading}
                                                pagination={false}
                                                rowSelection={rowSelection}
                                                columns={column}
                                                dataSource={referenceList.map((item: any, index: number) => ({
                                                    ...item,
                                                    key: item.transaction_id || index,
                                                }))}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div> : ""
                        }
                    </div>




                    <div>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: "pointer" }}>
                            Chargeback Description
                            <span style={{ color: 'red' }}> *</span>
                            <Tooltip
                                title={
                                    <span style={{ textTransform: 'capitalize' }}>
                                        With this description the customer grievance will be generated
                                    </span>
                                }
                            >
                                <img src={ExclamationCircle} alt="notCircle" height={16} width={16} />
                            </Tooltip>
                        </span>
                        <TextArea
                            required
                            rows={4}
                            placeholder="Chargeback Description"
                            value={_props.form.complaint_description}
                            onChange={(e) =>
                                _props.handleChange('complaint_description', e.target.value)
                            }
                        />
                    </div>

                    <Flex vertical>
                        <span>Dispute Amount</span>
                        <Input
                            disabled={_props.disable}
                            placeholder="Dispute Amount"
                            value={_props.form.dispute_amount?.amount}
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                const max = maxAmount;
                                if (value <= max) {
                                    _props.handleChange('dispute_amount', { amount: value });
                                }
                            }}
                        />
                        <div style={{ padding: '10px 3px', color: '#00000040' }}>
                            Maximum: ₹{maxAmount}
                        </div>
                    </Flex>

                </Flex>
            </form>
        </div>
    );
};
